import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner-loader',
  standalone: false,
  templateUrl: './spinner-loader.component.html',
  styleUrl: './spinner-loader.component.scss'
})
export class SpinnerLoaderComponent {
  @Input() inline = false;
  @Input() size: 'sm' | 'md' | 'lg' | 'icon' = 'md';
  @Input() delay = 800;
}
